import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, RouterOutlet } from '@angular/router';
import { slideInAnimation } from '../../animations';

@Component({
  templateUrl: './distributor-layout.component.html',
  styleUrls: ['./distributor-layout.component.scss'],
  animations: [
    slideInAnimation
  ]
})

export class DistributorLayoutComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
    $('body').addClass('distributor-layout');
  }

  prepareRoute(outlet: RouterOutlet) {
    return outlet && outlet.activatedRouteData && outlet.activatedRouteData['animation'];
  }

}
